import axios from 'axios';

async function ObtenerPartners(prmFiltro: string = '') {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_partners"
    
    let datosEnvio;
    
    if (prmFiltro) {
        datosEnvio = {"usuario": "mpatti", "clave": "all2GetHer_!", "filtro": prmFiltro}
    } else {
        datosEnvio = {"usuario": "mpatti", "clave": "all2GetHer_!"}
    }
    
    try {
        const response = await axios.post(url, datosEnvio);
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerPartners;